import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getActiveVehicleName } from 'selectors/getActiveVehicle'
import { CompatibleBrandResultList } from './CompatibleBrandResultList'

const mapStateToProps = state => ({
  vehicleName: getActiveVehicleName(state)
})

export default compose(
  withType({ type: 'CompatibleBrandResultList' }),
  connect(mapStateToProps)
)(CompatibleBrandResultList)
